<template>
  <section class="hero is-warning">
    <div class="hero-body">
      <div class="columns">
        <div class="column">
          <h3 class="title">
            <span class="icon">
              <i class="mdi mdi-email"></i>
            </span>
            Contact
          </h3>
          <p class="subtitle is-5">Inspiration, suggestions, pro-tips, emotional support, whatever it is - send it!</p>
          
        </div>
        <div class="column">
          <form name="contact" method="post" netlify>
            <div class="field hidden" for="name">
              <label class="label">name</label>
              <div class="control">
                <input class="input" type="name" name="name" placeholder="name" maxlength=30 v-model="name"></input>
              </div>
            </div>
            <div class="field" for="email">
              <label class="label">Email</label>
              <div class="control">
                <input class="input" type="email" name="email" placeholder="email" maxlength=30 v-model="email"></input>
              </div>
            </div>
            <div class="field" for="message">
              <label class="label">Message</label>
              <div class="control">
              </div>
                <textarea class="textarea" type="textarea" name="message" placeholder="Enter your message here" maxlength=1000 v-model="message"></textarea>
            </div>
            <input class="button" type="submit" :disabled="disabled" @click="onSubmit"></input>
          </form>
        </div>
      </div>
      
    </div>
  </section>
</template>

<script>
export default {
  name: "ContactForm",
  data() {
    return {
      name: null, // fake field, should always be null
      email: "",
      message: ""
    };
  },
  computed: {
    disabled() {
      return this.name !== null || this.email === "" || this.message === "";
    }
  },
  methods: {
    onSubmit() {
      !this.disabled &&
        console.log({
          name: this.name,
          email: this.email,
          message: this.message
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hidden {
  display: none;
}
.hero-body {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/ContactForm.vue